export const projectsData = [
  {
    id: 1,
    title: "StayEasy",
    description: "A full-stack accommodation discovery and booking platform where users can search places, view detailed listings, add properties, post reviews, and book stays with secure authentication.",
    emoji: "🏠",
    tech: ["EJS", "Node.js", "Express", "MongoDB", "Bootstrap"],
    link: "https://stay-easy-m7sk.onrender.com",
    github: "https://github.com/kalyan021004/StayEasy"
  },
{
  id: 2,
  title: "DigitalConnect",
  description: "A unified multilingual e-governance platform designed for rural communities. DigitalConnect enables citizens to access government welfare schemes, book doctor appointments, submit and track grievances, and interact with local authorities such as Gram Panchayats. The platform supports role-based access for citizens, doctors, state administrators, and panchayat officials, ensuring transparent service delivery and efficient governance.",
  emoji: "🌾",
  tech: [
    "React",
    "Node.js",
    "Express",
    "MongoDB",
    "JWT Authentication",
    "i18next (Multilingual Support)",
    "Bootstrap"
  ],
  link: "https://rural-connect-smoky.vercel.app",
  github: "https://github.com/kalyan021004/DigitalConnect"
},

  {
    id: 3,
    title: "TaskManagementPortal",
    description: "A real-time collaborative project management platform featuring Kanban boards, drag-and-drop task handling, team collaboration, live updates using WebSockets, authentication, and scalable backend architecture.",
    emoji: "📊",
    tech: [
      "React",
      "Redux Toolkit",
      "Node.js",
      "Express",
      "MongoDB",
      "Socket.io",
      "JWT",
      
    ],
link: "https://task-manager-portal-zxpw.vercel.app/",
    github: "https://github.com/kalyan021004/TaskManagerPortal_"
  }
];
